/**
 * Some attribute, classes... are only relevant if the JS is there
 * This module helps declaring such attribute and classes through
 * `js-with-js` prefixed classes. The class follows the pattern:
 * `js-with-js--<actionName>__<argument1>--<argument2>`. For example:
 *
 * js-with-js--addAttribute__aria-live--polite
 * js-with-js--removeClass__d-none
 * js-with-js--removeAttribute__hidden
 * @module embed/with_js
 */

const SELECTOR = '[class*="js-with-js"]';

const ACTIONS = {
  linkRadio: function(el) {
    el.classList.remove('bcs-radio');
    el.classList.add('bcs-linkRadio');
  },
  linkRadioCollection: function(el) {
    el.classList.remove('bcs-radioCollection');
    el.classList.remove('bcs-radioCollection--thirds');
    el.classList.add('d-inline-block');
  },
  injectText: function(el) {
    el.parentNode.replaceChild(document.createTextNode(el.innerText), el);
  },
  addClass: function(el, className) {
    el.classList.add(className);
  },
  removeClass: function(el, className) {
    el.classList.remove(className);
  },
  addAttribute: function(el, attributes) {
    const [attributeName, attributeValue] = attributes.split('--');
    if (attributeName == 'data-toggle-target') {
      el.setAttribute(attributeName, '#' + attributeValue);
    } else {
      el.setAttribute(attributeName, attributeValue || '');
    }
  },
  removeAttribute: function(el, attribute) {
    el.removeAttribute(attribute);
  }
};

function prepareElement(el) {
  Array.from(el.classList)
    .filter(c => /js-with-js--/.test(c))
    .map(c => {
      const [actionName, param] = c.replace(/js-with-js--/, '').split('__');
      const action = ACTIONS[actionName];
      if (action) {
        action(el, param);
      }
    });
}

/**
 * @function setupWithJS
 * @param {HTMLElement} el The element inside which to lookup for elements to run with-js on
 */
export default function setupWithJS(el) {
  Array.from(el.querySelectorAll(SELECTOR)).forEach(prepareElement);
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/with_js.js